//react...
import React from "react";

import "./Examinations.styles.css";

const MohammadaliRezaeeKardo = () => {
  return (
    <div className="examination-container">
      <div className="box">
        <div className="name"> Mr. Mohammadali Rezaee Kardo </div>

        <div className="score"> score: 93 / 100 </div>
      </div>
    </div>
  );
};

export default MohammadaliRezaeeKardo;
